import { render, staticRenderFns } from "./sliderNew.vue?vue&type=template&id=d469dd5a&scoped=true&"
import script from "./sliderNew.vue?vue&type=script&lang=js&"
export * from "./sliderNew.vue?vue&type=script&lang=js&"
import style0 from "./sliderNew.vue?vue&type=style&index=0&id=d469dd5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d469dd5a",
  null
  
)

export default component.exports